// src/components/PaymentLink.tsx

import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { useParams } from 'react-router-dom';
import { get, post } from '../httpService';

interface PaymentData {
    id: number;
    payment_link_uuid: string;
    user_id: number;
    group_id: number | null;
    description: string;
    image_url: string;
    amount: string;
    created_at: string;
    updated_at: string;
}

interface ApiResponse {
    code: number;
    message: string;
    data: PaymentData[];
}

function PaymentLink() {
    const { ReqId } = useParams<{ ReqId: string }>(); // Récupérer le paramètre ReqId depuis le chemin
    const [paymentData, setPaymentData] = useState<PaymentData | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const [providerId, setProviderId] = useState<number | null>(null);
    const [country, setCountry] = useState<string | null>(null);
    const [isLoad, setisLoad] = useState<boolean>(false);
    const [acceptTerme, setacceptTerme] = useState<boolean>(false);

    const { reset, register, handleSubmit, formState: { errors } } = useForm();

    const fetchPaymentData = async () => {
        if (!ReqId) {
            setError('Aucun Identifiant de requête fourni.');
            return;
        }

        setIsLoading(true);

        try {
            const postData = {
                payment_link_uuid: ReqId,
            };

            post('/payment-link/get-data', postData).then((response) => {
                if (response.data.code === 200 && response.data.data != null) {
                    setPaymentData(response.data.data); // Assurez-vous de prendre le premier élément
                } else {
                    setError('Données de paiement non trouvées.');
                }
            });


        } catch (err) {
            console.error(err);
            setError('Erreur lors de la récupération des données.');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPaymentData();
    }, [ReqId]);

    const onSubmit = async (data: any) => {

        if (country === null || country === "Select") {
            alert("Sélectionnez le pays");
            return;
        }

        if (providerId === null) {
            alert("Sélectionnez le mode de paiement");
            return;
        }

        if (!acceptTerme) {
            alert("Veuillez accepter les termes et conditions de Seremo");
            return;
        }

        if (!paymentData) {
            alert("Données de paiement manquantes.");
            return;
        }

        const postData = {
            "to_user_id": paymentData.user_id,
            "rT": (data.phone).toString(),
            "rMt": paymentData.amount,
            "rMo": providerId,
            "rOTP": 1234,
            "group_id": paymentData.group_id,
            "amount": paymentData.amount,
            "reason": paymentData.description,
            "note": paymentData.description,
            'payer_first_name': data.name,
            'payer_last_name': data.lastName,
            'payer_email': data.email,
        };
        console.log(paymentData.group_id == null);

        try {
            setisLoad(true);

            var link = paymentData.group_id == null ? "/payment-link/pay" : "/payment-link/contribute";


            post(link, postData).then((response) => {
                if (response.data.code === 200) {
                    setisLoad(false);
                    alert(response.data.message);
                    reset();
                } else {
                    alert(response.data.message);
                    setisLoad(false);
                }
            }).catch((error) => {
                setisLoad(false);
                console.log(error);
            });


        } catch (error) {
            setisLoad(false);
            alert("Une erreur est survenue, veuillez réessayer plus tard.");
        }
    };

    const setProviverId = (id: number | null) => {
        setProviderId(id);
    };

    const returnCountryCode = (country: string): string => {
        const countryCodes: { [key: string]: string } = {
            "France": "33",
            "Cameroun": "237",
            "Canada": "1",
            "Usa": "1",
            "Allemagne": "49",
            "Belgique": "32",
        };
        return countryCodes[country] || "";
    };

    const returnCountryCurrency = (country: string): string => {
        const countryCurrencies: { [key: string]: string } = {
            "Cameroun": "XAF",
            "Usa": "USD",
            "Canada": "CAD",
            "Allemagne": "EUR",
            "Belgique": "EUR",
            "France": "EUR",
        };
        return countryCurrencies[country] || "";
    };

    return (
        <div className="bg-gray min-h-screen flex items-center justify-center p-4">
            <div className="w-full max-w-5xl bg-white rounded-lg p-6">
                <div className="text-center mb-6">
                    <h2 className="text-xl font-semibold text-gray-dark">Powered by Diba Pay</h2>
                    <hr className='text-grey mt-4' />
                    {/* <img src="https://www.seremo.co/static/media/logo-text-no-bg.52f67947.png" alt="logo" className='mx-auto' /> */}
                </div>

                {isLoading ? (
                    // Skeleton Loader
                    <div className="animate-pulse">
                        <div className="flex flex-col md:flex-row">
                            {/* Skeleton for Payment Information */}
                            <div className="md:w-1/2 p-5">
                                <div className="p-6 mt-2 bg-gray-300 rounded-lg shadow">
                                    <div className="h-6 bg-gray-400 rounded w-3/4 mb-4"></div>
                                    <div className="h-8 bg-gray-400 rounded w-1/2 mx-auto"></div>
                                </div>
                            </div>

                            {/* Skeleton for Payment Form */}
                            <div className="md:w-1/2 p-4 shadow-lg rounded-lg bg-white">
                                {/* Nom et Prénom */}
                                <div className="mb-4">
                                    <div className="h-10 bg-gray-300 rounded w-full mb-2"></div>
                                    <div className="h-4 bg-gray-400 rounded w-1/3"></div>
                                </div>

                                {/* Adresse e-mail */}
                                <div className="mb-4">
                                    <div className="h-10 bg-gray-300 rounded w-full mb-2"></div>
                                    <div className="h-4 bg-gray-400 rounded w-1/3"></div>
                                </div>

                                {/* Pays */}
                                <div className="mb-4">
                                    <div className="h-10 bg-gray-300 rounded w-full mb-2"></div>
                                    <div className="h-4 bg-gray-400 rounded w-1/3"></div>
                                </div>

                                {/* Méthode de Paiement */}
                                <div className="mb-4">
                                    <div className="h-6 bg-gray-300 rounded w-1/4 mb-2"></div>
                                    <div className="flex space-x-4">
                                        <div className="flex items-center">
                                            <div className="h-4 w-4 bg-gray-400 rounded-full mr-2"></div>
                                            <div className="h-6 bg-gray-300 rounded w-20"></div>
                                        </div>
                                        <div className="flex items-center">
                                            <div className="h-4 w-4 bg-gray-400 rounded-full mr-2"></div>
                                            <div className="h-6 bg-gray-300 rounded w-20"></div>
                                        </div>
                                        <div className="flex items-center">
                                            <div className="h-4 w-4 bg-gray-400 rounded-full mr-2"></div>
                                            <div className="h-6 bg-gray-300 rounded w-20"></div>
                                        </div>
                                    </div>
                                </div>

                                {/* Numéro de Téléphone */}
                                <div className="mb-4">
                                    <div className="h-10 bg-gray-300 rounded w-1/4 mb-2"></div>
                                    <div className="h-10 bg-gray-300 rounded w-full"></div>
                                </div>

                                {/* Termes et Conditions */}
                                <div className="mb-4 flex items-center">
                                    <div className="h-4 w-4 bg-gray-300 rounded mr-2"></div>
                                    <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                                </div>

                                {/* Bouton Soumettre */}
                                <div className="text-center">
                                    <div className="h-10 bg-gray-300 rounded w-full"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : error ? (
                    <div className="text-center text-red-500 text-xl">{error}</div>
                ) : paymentData ? (
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="flex flex-col md:flex-row">
                            {/* Informations de Paiement */}
                            <div className="md:w-1/2 p-5">
                                <div className="mt-2 bg-gray-50 text-start">
                                    <div className="text-3xl font-bold text-blue">Payer : {paymentData.amount} XAF</div>
                                    <p className="text-lg mb-4 mt-2">{paymentData.description}</p>
                                </div>
                                {paymentData.image_url != null && <>
                                    <img src={paymentData.image_url} alt="" className='w-100' />
                                </>}
                            </div>

                            {/* Formulaire de Paiement */}
                            <div className="md:w-1/2 p-8 shadow-lg rounded-lg bg-white">
                                {/* Nom et Prénom */}

                                <div className="mb-4">
                                    <input
                                        type="text"
                                        className={`w-full px-3 py-2 border ${errors.name ? 'border-red-500' : 'border-gray-light'} rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                        placeholder="Nom"
                                        {...register("name", { required: true })}
                                    />
                                    {errors.name && <span className='text-red-500 text-sm'>Nom obligatoire</span>}
                                </div>

                                <div className="mb-4">
                                    <input
                                        type="text"
                                        className={`w-full px-3 py-2 border ${errors.lastName ? 'border-red-500' : 'border-gray-light'} rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                        placeholder="Prénom"
                                        {...register("lastName", { required: true })}
                                    />
                                    {errors.lastName && <span className='text-red-500 text-sm'>Prénom obligatoire</span>}
                                </div>

                                {/* Adresse e-mail */}
                                <div className="mb-4">
                                    <input
                                        type="email"
                                        className={`w-full px-3 py-2 border ${errors.email ? 'border-red-500' : 'border-gray-light'} rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                        placeholder="Adresse e-mail"
                                        {...register("email", { required: true })}
                                    />
                                    {errors.email && <span className='text-red-500 text-sm'>Email obligatoire</span>}
                                </div>

                                {/* Pays */}
                                <div className="mb-4">
                                    <select
                                        className={`w-full px-3 py-2 border ${errors.country ? 'border-red-500' : 'border-gray-light'} rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                        {...register("country", { required: true })}
                                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                            setCountry(e.target.value);
                                            if (e.target.value !== "Cameroun") {
                                                setProviverId(1);
                                            } else {
                                                setProviverId(null);
                                            }
                                        }}
                                    >
                                        <option value="Select">Pays</option>
                                        <option value="Cameroun">Cameroun</option>
                                        <option value="Usa">États-Unis</option>
                                        <option value="France">France</option>
                                        <option value="Canada">Canada</option>
                                        <option value="Belgique">Belgique</option>
                                        <option value="Allemagne">Allemagne</option>
                                    </select>
                                    {errors.country && <span className='text-red-500 text-sm'>Pays obligatoire</span>}
                                </div>

                                {/* Méthode de Paiement */}
                                <div className="mb-4">
                                    <p className="mb-2 font-semibold">Méthode de Paiement</p>
                                    <div className="flex space-x-4">
                                        {/* Orange Money */}
                                        <label className={`flex items-center cursor-pointer ${country !== "Cameroun" ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                            <input
                                                type="radio"
                                                name="provider"
                                                value="3"
                                                onClick={() => setProviverId(2)}
                                                disabled={country !== "Cameroun"}
                                                className="form-radio h-4 w-4 text-blue-600"
                                            />
                                            <img className="w-8 h-8 ml-2" src={`${process.env.PUBLIC_URL}/images/orange.png`} alt="Orange Money" />
                                            <span className="ml-2">Orange Money</span>
                                        </label>

                                        {/* MTN Mobile Money */}
                                        <label className={`flex items-center cursor-pointer ${country !== "Cameroun" ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                            <input
                                                type="radio"
                                                name="provider"
                                                value="2"
                                                onClick={() => setProviverId(1)}
                                                disabled={country !== "Cameroun"}
                                                className="form-radio h-4 w-4 text-blue-600"
                                            />
                                            <img className="w-8 h-8 ml-2" src={`${process.env.PUBLIC_URL}/images/mtn.png`} alt="MTN Mobile Money" />
                                            <span className="ml-2">MTN Mobile Money</span>
                                        </label>

                                        {/* Paypal */}
                                        <label className={`flex items-center cursor-pointer ${country === "Cameroun" ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                            <input
                                                type="radio"
                                                name="provider"
                                                value="1"
                                                onClick={() => setProviverId(3)}
                                                disabled={country === "Cameroun"}
                                                className="form-radio h-4 w-4 text-blue-600"
                                            />
                                            <img className="w-8 h-8 ml-2" src={`${process.env.PUBLIC_URL}/images/paypal.png`} alt="Paypal" />
                                            <span className="ml-2">Paypal</span>
                                        </label>
                                    </div>
                                </div>

                                {/* Numéro de Téléphone */}
                                <div className="mb-4">
                                    <div className="flex">
                                        <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-light bg-gray-50 text-gray-500 text-sm">
                                            + {country && <span className='countryCode'>{returnCountryCode(country)}</span>}
                                        </span>
                                        <input
                                            type="text"
                                            className={`flex-1 min-w-0 block w-full px-3 py-2 border ${errors.phone ? 'border-red-500' : 'border-gray-light'} rounded-r-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                            placeholder="Numéro mobile money"
                                            {...register("phone", { required: true })}
                                        />
                                    </div>
                                    {errors.phone && <span className='text-red-500 text-sm'>Téléphone obligatoire</span>}
                                </div>

                                {/* Termes et Conditions */}
                                <div className="mb-4 flex items-center">
                                    <input
                                        type="checkbox"
                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-light rounded"
                                        onChange={() => setacceptTerme(!acceptTerme)}
                                    />
                                    <label className="ml-2 text-sm">
                                        En cochant cette case, vous acceptez les <a href='https://www.seremo.co/#/terms' target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">termes et conditions</a> de Diba Pay
                                    </label>
                                </div>

                                {/* Bouton Soumettre */}
                                <div className="text-center">
                                    <button
                                        type="submit"
                                        className="w-full bg-blue text-white py-2 px-4 rounded-md hover:bg-blue-700 transition duration-200"
                                        disabled={isLoad}
                                    >
                                        {!isLoad ? "Payer" : "Traitement..."}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                ) : (
                    <div className="text-center text-xl">Traitement en cours...</div>
                )}
            </div>
        </div>
    );
}

export default PaymentLink;
